<div class="container-fluid inv-box">
  <div class="row inv-container">
    <div class="col-3">
      <h3 [style.color]="mainColor" class="inv-title">Contact request</h3>

      <p class="inv-text">Someone wants to share a project with you. Please choose whether you like to connect to that contact or not.</p>

      <p class="inv-text">
        <span style="font-weight: bolder">Please note</span>, if you like to stop sharing a project or end your participation in a project, you can do so within the sharing feature on the 'projects page' anytime and for
        every project individually.
      </p>
    </div>

    <div class="col-9 col-md-offset-2" style="margin-top: 30px">
      <h3 class="inv-subtitle">Pending contact sharing request</h3>
      <div *ngrxLet="contacts$ as contacts">
        <p *ngIf="contacts" class="inv-text">
          If you like to give <span class="highlight">{{ contacts.from_user_info.full_name }}</span> the permission to share projects with you, please click on the 'Permit' button below. You will then be added to his
          contact list. <br />
          Also {{ contacts.from_user_info.full_name }} will appear on your contact list, if you wish to share one of your projects with {{ contacts.from_user_info.full_name }}. If you don't want to be linked to this
          contact, simply click 'Deny'.
        </p>
      </div>

      <usimweb-button (btnClick)="permit()" text="Permit" style="margin-right: 15px"></usimweb-button>
      <usimweb-button (btnClick)="deny()" text="Deny" color="#dc3545"></usimweb-button>
    </div>
  </div>
</div>
